import { NetworkManager } from "./network/NetworkManager";
import { StateManager } from "./state/StateManager";
import { AssetLoader } from "./assets/AssetLoader";
import { getEnv } from "./config/env";

/**
 * One instance per running client, created in main.ts and handed to every
 * Scene via Phaser's registry (`this.game.registry.get("ctx")`) — this is
 * how scenes reach NetworkManager without each one constructing its own
 * (which would violate the "only place fetch()/WebSocket are called
 * directly" rule in Part 3's M16 description).
 */
export interface GameContext {
  network: NetworkManager;
  state: StateManager;
  assets: AssetLoader;
  /** Set once character-select resolves a chosen character; read by
   * in-world scenes/panels. */
  selectedCharacterId: string | null;
}

export function createGameContext(): GameContext {
  const env = getEnv();
  return {
    network: new NetworkManager({ apiBase: env.apiBase }),
    state: new StateManager(),
    assets: new AssetLoader(env.assetCdn),
    selectedCharacterId: null,
  };
}
